import React from "react";
import { notify } from "@/shared/utils/notify";
import { rulesSushiLunchService } from "../../../shared/services";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { SelectedDaysType } from "../ui";
import { IRulesSushiLunch } from "../../../redux/@types/rulesSushiLunch";

export const useEditRulesSushiLunch = ({
  setOpenModalEditRule,
  ruleById,
  days,
}: {
  setOpenModalEditRule: (val: boolean) => void;
  ruleById: IRulesSushiLunch | undefined;
  days: SelectedDaysType;
}) => {
  const [loading, setLoading] = React.useState<boolean>(false);

  const {
    control,
    handleSubmit: onSubmit,
    reset,
    setValue,
  } = useForm<any>({
    resolver: yupResolver(
      yup.object({
        name: yup.string().required("Campo requerido"),
        status: yup.string().required("Campo requerido"),
        apply_to: yup.string().required("Campo requerido"),
        start_time: yup.string().required("Campo requerido"),
        end_time: yup.string().required("Campo requerido"),
      })
    ),
  });

  React.useEffect(() => {
    if (ruleById) {
      setValue("name", ruleById.name);
      setValue("status", ruleById.status);
      setValue("apply_to", ruleById.apply_to);
      setValue("start_time", ruleById.start_time);
      setValue("end_time", ruleById.end_time);
      setValue("banner_path", ruleById.banner_path);
    }
  }, [ruleById, setValue]);

  const editRule = onSubmit(async (data: any) => {
    if (loading || !ruleById) return;

    setLoading(true);
    await rulesSushiLunchService
      .patch(ruleById.id, {
        ...data,
        monday: days.monday,
        tuesday: days.tuesday,
        wednesday: days.wednesday,
        thursday: days.thursday,
        friday: days.friday,
        saturday: days.saturday,
        sunday: days.sunday,
      })
      .then((_res: any) => {
        notify.success(`Se ha actualizado la regla exitosamente`);
        setOpenModalEditRule(false);
        reset({});
      })
      .catch((err: any) => {
        notify.error(err.message);
        return err.message;
      })
      .finally(() => {
        setLoading(false);
      });
  });

  return {
    loading,
    control,
    editRule,
    setValue,
  };
};
